import { Route, Routes as ReactRoutes, useLocation } from "react-router-dom";
import LoginRoute from "./LoginRoute";
import Login from "../modules/auth/containers/Login";
import routePaths from "./routePaths";
import PrivateRoute from "./PrivateRoute";
import { AppRouteInterface } from "@mv-types";
import PageNotFound from "@components/ErrorBoundary/PageNotFound";
import NoPageAccess from "@components/ErrorBoundary/NoPageAccess";

const Routes = (props: { routes: AppRouteInterface[] }) => {
	const { routes } = props;
	const location = useLocation();
	const HomeComponent = routes[0]?.component;
	return (
		<ReactRoutes>
			<Route
				path={routePaths.LOGIN}
				element={
					<LoginRoute path={routes[0]?.path}>
						<Login />
					</LoginRoute>
				}
			/>

			<Route
				path={routePaths.HOME}
				element={<PrivateRoute>{routes[0]?.path ? <HomeComponent /> : <NoPageAccess />}</PrivateRoute>}
			/>

			{routes.map((routeConfig, index) => {
				const Component = routeConfig.component;
				return (
					<Route
						key={`route_item_${index}`}
						path={routeConfig.path}
						element={
							<PrivateRoute>
								<Component />
							</PrivateRoute>
						}
					/>
				);
			})}
			<Route
				path={"/*"}
				element={Object.values(routePaths).includes(location.pathname) ? <NoPageAccess /> : <PageNotFound />}
			/>
		</ReactRoutes>
	);
};

export default Routes;
